import React, { useEffect } from 'react';
import { PillTabs, I18nText } from '@welldev-group/react-comp-lib';
import PropTypes from 'prop-types';
import { StringParam, withDefault, useQueryParams } from 'use-query-params';
import withQueryParamsProvider from '../../../../../../shared/components/withQueryParamsProvider';
import List from './UserList';

const UserTab = ({
  id,
  urls,
  currentUserId,
  signedInAsSuperAdmin,
  permissionTemplateOptions,
  permissionOptions,
}) => {
  const [query, setQuery] = useQueryParams({
    tab: withDefault(StringParam, ''),
  });

  const { tab } = query;

  const getItems = () => [
    {
      key: 0,
      title: <I18nText id="user.list.status.active" />,
      getContent: () => (
        <List
          key="active"
          status="active"
          id={id}
          urls={urls}
          currentUserId={currentUserId}
          signedInAsSuperAdmin={signedInAsSuperAdmin}
          permissionTemplateOptions={permissionTemplateOptions}
          permissionOptions={permissionOptions}
          userAffiliateId={id}
        />
      ),
    },
    {
      key: 1,
      title: <I18nText id="user.list.status.deactivated" />,
      getContent: () => (
        <List
          key="deactivated"
          status="deactivated"
          id={id}
          urls={urls}
          currentUserId={currentUserId}
          signedInAsSuperAdmin={signedInAsSuperAdmin}
          permissionTemplateOptions={permissionTemplateOptions}
          permissionOptions={permissionOptions}
          userAffiliateId={id}
        />
      ),
    },
    {
      key: 2,
      title: <I18nText id="user.list.status.pending" />,
      getContent: () => (
        <List
          key="pending"
          status="pending"
          id={id}
          urls={urls}
          currentUserId={currentUserId}
          signedInAsSuperAdmin={signedInAsSuperAdmin}
          permissionTemplateOptions={permissionTemplateOptions}
          permissionOptions={permissionOptions}
          userAffiliateId={id}
        />
      ),
    },
  ];

  useEffect(() => {
    setQuery({ tab: 'users' }, 'replaceIn');
  }, [tab]);

  return (
    <div className="col-grid col-bleed">
      <PillTabs items={getItems()} tab={tab} />
    </div>
  );
};

UserTab.defaultProps = {
  permissionTemplateOptions: [],
};

UserTab.propTypes = {
  id: PropTypes.number.isRequired,
  signedInAsSuperAdmin: PropTypes.bool.isRequired,
  urls: PropTypes.shape({
    users: PropTypes.string.isRequired,
    invites: PropTypes.string.isRequired,
    teams: PropTypes.string.isRequired,
  }).isRequired,
  permissionOptions: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string))
    .isRequired,
  permissionTemplateOptions: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      permissions: PropTypes.arrayOf(PropTypes.string).isRequired,
    }),
  ),
  currentUserId: PropTypes.number.isRequired,
};

export default withQueryParamsProvider(UserTab);
